
export const common = {
  getSelectList() {
    // TODO: replace with real API
    return Promise.resolve({ year: [], period: [] })
    // return getRequest('/index/xunjian/selectList')
  },
  getBusinessSelectList() {
    // TODO: replace with real API
    return Promise.resolve({ business: [], task: [] })
    // return getRequest('/index/xunjian/businessSelectList')
  },
  getValidMonthList() {
    // TODO: replace with real API
    return Promise.resolve({ year: [], period: [] })
    // return getRequest('/index/xunjian/validMonthList')
  }
}

export default { common }
